import { MouseEvent, useCallback, useContext, useEffect, useRef, useState } from "react";
import { IGridContentProps } from "./GridContent.interface";
import CardLogo from "./../../../shared/assets/imgs/card_logo.svg";
import { delay, markdownToHtml } from "../../../shared/helpers/utils";
import Button from "../../Button/Button";
import { ModuleContext } from "../../../shared/providers/module/module.provider";
import { TranslationContext } from "../../../shared/providers/translation/translation.provider";
import { ComponentTypes } from "../../../shared/interfaces/modules.interface";

function GridContent({ gridItems, unitId, id }: IGridContentProps) {

    const [stagedItem, setStagedItem] = useState<number>();
    const flipCard = useRef<HTMLDivElement>(null);
    const { lang } = useContext(TranslationContext);
    const { setProgress } = useContext(ModuleContext);
    const [cardsOpened, setCardsOpened] = useState<number[]>([]);

    const handleProgress = useCallback(() => {
        if (lang && unitId) {
            setProgress({
                unitId: unitId,
                itemId: id,
                progress: 100,
                itemType: ComponentTypes.GRID_CONTENT,
                itemLocale: lang
            });
        }
    }, [lang, unitId]);

    useEffect(() => {
        if (cardsOpened.length === gridItems.length) {
            handleProgress()
        }
    }, [cardsOpened, gridItems])

    const onClickCard = async (e: MouseEvent<HTMLButtonElement>) => {
        if (!flipCard.current) return;

        const btn = (e.target as HTMLButtonElement);
        const cardIndex = Number(btn.dataset.index);
        setStagedItem(cardIndex);
        
        if (cardIndex !== undefined && !cardsOpened.includes(cardIndex)) {
            setCardsOpened(opened => ([...opened, cardIndex]));
        }

        const initPosition = btn.getBoundingClientRect();

        const card = flipCard.current;
        const cardFront = card.querySelector(".front")!;
        cardFront.innerHTML = btn.innerHTML;

        card.setAttribute("style", `
        --init-width:${initPosition.width}px;
        --init-top:${initPosition.top}px;
        --init-left:${initPosition.left}px
        `);

        await delay(10);

        card.classList.add("flip");

        await delay(500);

        card.style.setProperty("--init-width", "726px");
        await delay(500);

        card.classList.add("flipped");

        document.body.addEventListener("click", clickOutside);
    }

    const handleClose = () => {
        if (!flipCard.current) return;
        const card = flipCard.current;

        card.classList.remove("flip");
        card.classList.remove("flipped");
        card.removeAttribute("style");
        setStagedItem(undefined);

        document.body.removeEventListener("click", clickOutside);
    }

    const clickOutside = useCallback(({ target }: Event) => {
        if (!flipCard.current) return;
        const card = flipCard.current;

        if (target === card || card.contains(target as Node)) return;

        handleClose();
    }, [flipCard])

    useEffect(() => {

        if (stagedItem !== undefined) {
            document.body.classList.add("overflow-hidden");
        } else {
            document.body.classList.remove("overflow-hidden");
        }

    }, [stagedItem])



    return (
        <>
            <div className="grid_content">
                {gridItems.map((item, i) => <button
                    type="button"
                    key={i}
                    className="card card_grid"
                    data-index={i}
                    onClick={onClickCard}>
                    <img src={CardLogo} />
                    <h2 className="text-bd1-rg text-center">{item.title}</h2>
                </button>)}
                <div
                    className="card card_flip"
                    ref={flipCard}>
                    <div className="front">
                    </div>
                    <div className="back">
                        <Button
                            type="button"
                            icon="Close"
                            iconSize={40}
                            onClick={handleClose}
                        />
                        <img className="card_img" src={CardLogo} />
                        {stagedItem !== undefined && <>
                            <h2 className="text-h3-smbd text-left">{gridItems[stagedItem].title}</h2>
                            <div className="text-bd2-rg color-neutrals-dark rich_text" dangerouslySetInnerHTML={{
                                __html: markdownToHtml(gridItems[stagedItem].content)
                            }}></div>
                        </>}

                    </div>
                </div>
            </div>
        </>
    );
}

export default GridContent;
